import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { BixiACDirective } from './ac.directive';

@NgModule({
  imports: [CommonModule],
  declarations: [BixiACDirective],
  exports: [BixiACDirective]
})
export class BixiACModule { }
